export function getOAuthCode(): string | null {
  if (typeof window === "undefined") return null;
  const url = new URL(window.location.href);
  return url.searchParams.get("oauth_code");
}

export function clearOAuthUrl(): void {
  if (typeof window === "undefined") return;
  const url = new URL(window.location.href);
  url.searchParams.delete("oauth_code");
  url.searchParams.delete("oauth");
  url.searchParams.delete("provider");
  window.history.replaceState({}, "", url.pathname + (url.search || "") || "/");
}
